import { useState, useEffect } from 'react';
import { skinSeoulProductsClient } from '../../../infrastructure/SkinSeoulProductsClient';
import type { SkinSeoulAdminProduct } from '../../../models/ProductTypes';

interface UsePublishedProductsResult {
  products: SkinSeoulAdminProduct[];
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const usePublishedProducts = (skus: string[]): UsePublishedProductsResult => {
  const [products, setProducts] = useState<SkinSeoulAdminProduct[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  useEffect(() => {
    if (skus.length === 0) {
      setProducts([]);
      return;
    }

    const fetchProducts = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await skinSeoulProductsClient.getProductsBySku(skus);
        setProducts(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch products'));
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [skus.join(','), refetchTrigger]); // eslint-disable-line react-hooks/exhaustive-deps

  const refetch = () => {
    setRefetchTrigger((prev) => prev + 1);
  };

  return { products, loading, error, refetch };
};
